import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'
import { mapValues } from 'lodash'
import * as actions from '@/store/static/reservation/number-actions.js'

const Numbers = () => import(/* webpackChunkName: "reservations" */'@/views/reservation/Numbers')
const NumberTabs = () => import(/* webpackChunkName: "reservations" */'@/views/reservation/number/NumberTabs')
const Overview = () => import(/* webpackChunkName: "reservations" */'@/views/reservation/number/Overview')
const ActionsLogs = () => import(/* webpackChunkName: "customers" */'@/views/reservation/number/actions-logs/ActionsLogs')
const ManageNumber = () => import(/* webpackChunkName: "reservations" */'@/views/reservation/number/ManageNumber')
const ImportNumber = () => import(/* webpackChunkName: "reservations" */'@/views/reservation/number/ImportNumber')
const NumberService = () => import(/* webpackChunkName: "customers" */'@/views/customer/customer/product/number/number/Service')

function props ({params}) {
    return {
        ...params,
        ...mapValues(props, (prop) => !isNaN(prop) ? Number(prop) : prop)
    }
}

export default {
    path: '/reservation/numbers',
    alias: '/reservation',
    component: BaseRouterView,
    children: [
        {
            path: '/',
            name: routeNames.RESERVATION_NUMBERS,
            meta: {title: 'Numbers Management'},
            component: Numbers,
            props
        },
        {
            path: 'import',
            name: routeNames.RESERVATION_NUMBER_IMPORT,
            component: ImportNumber,
            meta: {title: 'Import Number'},
            props,
        },
        {
            path: 'reserve/:serviceNumber',
            name: routeNames.RESERVATION_NUMBER_RESERVE,
            meta: {title: 'Reserve Number'},
            component: ManageNumber,
            props: (route) => ({
                serviceNumber: route.params.serviceNumber,
                action: actions.RESERVE
            }),
        },
        {
            path: 'sell/:serviceNumber',
            name: routeNames.RESERVATION_NUMBER_SELL,
            meta: {title: 'Sell Number'},
            component: ManageNumber,
            props: (route) => ({
                serviceNumber: route.params.serviceNumber,
                action: actions.SELL
            }),
        },
        {
            path: ':serviceNumber',
            component: NumberTabs,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.RESERVATION_NUMBER,
                    meta: {title: 'Details'},
                    component: Overview,
                    props
                },
                {
                    path: 'service',
                    name: routeNames.RESERVATION_NUMBER_SERVICE,
                    meta: {title: 'Service'},
                    component: NumberService,
                    props
                },
                {
                    path: 'actions-logs',
                    name: routeNames.RESERVATION_NUMBER_ACTIONS_LOGS,
                    meta: {title: 'Action Logs'},
                    component: ActionsLogs,
                    props
                }
            ]
        }
    ]
}